'use client'

import { cn } from '~/utils/tailwind-utils'

interface AnimatedBorderProps {
  children: React.ReactNode
  size?: 'sm' | 'lg'
  borderWidth?: number
  duration?: number
}

export function AnimatedBorder({
  children,
  size = 'sm',
  borderWidth = 1,
  duration = 2,
}: AnimatedBorderProps) {
  const sizeClasses = {
    sm: 'w-9 h-9',
    lg: 'w-14 h-14',
  }

  const animatedDivSizeClasses = {
    sm: 'w-12 h-12',
    lg: 'w-24 h-24',
  }

  const animatedDivInset = borderWidth * (size === 'sm' ? 6 : 16)

  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-[9px]',
        sizeClasses[size],
      )}
    >
      <div
        className={cn(
          'absolute inset-0 z-0 animate-spin-slow',
          animatedDivSizeClasses[size],
        )}
        style={{
          inset: `-${animatedDivInset}px`,
          background: `conic-gradient(from 0deg, #3b82f6, #93c5fd, transparent, transparent, transparent, transparent, #93c5fd, #3b82f6)`,
          animationDuration: `${duration}s`,
        }}
      />
      <div className="absolute z-[2] m-[0_auto]">{children}</div>
      <div
        className="absolute z-[1] flex items-center justify-center overflow-hidden rounded-lg bg-gray-100 dark:bg-gray-700"
        style={{
          inset: `${borderWidth}px`,
        }}
      ></div>
    </div>
  )
}
